import type { SVGProps } from "react";
// generated from Star.svg — do not edit manually
// prettier-ignore
export default function Star(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 12 2 C 12.8454 7.132 16.8678 11.155 22 12 C 16.8678 12.845 12.8454 16.868 12 22 C 11.1546 16.868 7.1322 12.845 2 12 C 7.1322 11.155 11.1546 7.132 12 2 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
